import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableIcons from "../../common/TableLogoComponent";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ApiService from "../../../ApiService";
import Divider from "@material-ui/core/Divider";
import MaterialTable from "../../../components/MaterialTable";
/* import DownloadIcon from "@material-ui/icons/CloudDownload"; */
import {
  Alert,
  Autocomplete,
  /* FormControl, */ TextField,
} from "@mui/material";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import TableCell from "@material-ui/core/TableCell";
/* import TableContainer from "@material-ui/core/TableContainer"; */
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import CustomTooltip from "../../../components/Custom/Tooltip/Tooltip";
import { Button as MTButton } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";

import AddMerchantUrlComponent from "./AddMerchantUrlComponent";
import Button from "../../../components/Custom/Button/Button";
import { FormControl, TableHead } from "@material-ui/core";
import GridContainer from "../../../components/Custom/Grid/GridContainer";
import GridItem from "../../../components/Custom/Grid/GridItem";

const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
});

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
  return valid;
};
class MerchantComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchants: [],
      allMerchants: [],
      showDetails: false,
      selectedMerchant: null,
      merchant: null,
      merchantName: "",
      failed: false,
      success: false,
      responseMessage: null,
      addMerchantUrlPanelVisible: false,
      addMerchantPanelVisible: false,
      errors: {
        contactEmail: "",
        telephone: "",
        country: "",
      },
      editingMerchant: false,
    };
    this.fetchAllMerchants = this.fetchAllMerchants.bind(this);

    this.showAddMerchantUrlPanel = this.showAddMerchantUrlPanel.bind(this);
    this.hideAddMerchantUrlPanel = this.hideAddMerchantUrlPanel.bind(this);

    this.showAddMerchantDialogue = this.showAddMerchantDialogue.bind(this);
    this.hideAddMerchantDialogue = this.hideAddMerchantDialogue.bind(this);

    this.reloadData = this.reloadData.bind(this);
    this.showDetailsPanel = this.showDetailsPanel.bind(this);
    this.hideDetailsPanel = this.hideDetailsPanel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchUser = this.fetchUser.bind(this);

    this.startEditMerchant = this.startEditMerchant.bind(this);
    this.stopEditMerchant = this.stopEditMerchant.bind(this);
  }

  startEditMerchant() {
    this.setState({ editingMerchant: true });
  }
  stopEditMerchant() {
    this.fetchUser();
    this.setState({ editingMerchant: false });
  }

  fetchUser() {
    ApiService.getUserMerchant().then((res) => {
      if (res != null) {
        this.setState({
          id: res.data.id != null ? res.data.id : "",
          merchantName:
            res.data.merchantName != null ? res.data.merchantName : "",
          contactEmail:
            res.data.contactEmail != null ? res.data.contactEmail : "",
          address: res.data.address != null ? res.data.address : "",
          city: res.data.city != null ? res.data.city : "",
          country: res.data.country != null ? res.data.country : "",
          zip: res.data.zip != null ? res.data.zip : "",
          telephone: res.data.telephone != null ? res.data.telephone : "",
          fax: res.data.fax != null ? res.data.fax : "",
          orgRegistrationNumber:
            res.data.orgRegistrationNumber != null
              ? res.data.orgRegistrationNumber
              : "",
          industry: res.data.industry != null ? res.data.industry : "",
          website: res.data.website != null ? res.data.website : "",
        });
      }
    });
  }

  componentDidMount() {
    this.reloadData();
    this.fetchUser();
  }

  reloadData() {
    this.fetchAllMerchants();
  }

  fetchAllMerchants() {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data, allMerchants: res.data });
    });
  }

  showAddMerchantUrlPanel(data) {
    this.setState({
      selectedMerchant: data[0],
      addMerchantUrlPanelVisible: true,
    });
  }
  hideAddMerchantUrlPanel() {
    this.setState({ addMerchantUrlPanelVisible: false });
  }

  showAddMerchantDialogue() {
    this.setState({ addMerchantPanelVisible: true });
  }
  hideAddMerchantDialogue() {
    this.setState({ addMerchantPanelVisible: false });
  }

  openFile(id, fileName) {
    /*const file = new Blob([doc.data],{type: 'image/*'});
		 
		var link = document.createElement('a');
		link.href = URL.createObjectURL(file);
		link.download = doc.fileName;
  		document.body.appendChild(link);
    	link.click();
    	document.body.removeChild(link);*/
    ApiService.downloadMerchantDoc(id, fileName);
  }

  handleInputChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "telephone":
        errors.telephone =
          isNaN(value) || value.length !== 10 ? "Phone number not valid!" : "";
        break;
      case "contactEmail":
        errors.contactEmail = validEmailRegex.test(value)
          ? ""
          : "Contact Email is not valid!";
        break;
      case "country":
        errors.country =
          value.length < 2 ? "Country should only have 2 chars" : "";
        break;
      default:
        break;
    }

    const selectedMer = { ...this.state.selectedMerchant };
    selectedMer[name] = value;

    this.setState({ errors, selectedMerchant: selectedMer });
  }
  handleSubmit() {
    if (validateForm(this.state.errors)) {
      var request = Object.assign({}, this.state.selectedMerchant);

      ApiService.updateUserMerchant(request).then((res) => {
        if (res != null) {
          if (res.data.status === "OK") {
            this.setState({
              success: true,
              failed: false,
              responseMessage: res.data.responseMessage,
              showDetails: false,
            });
            this.reloadData();
            this.stopEditMerchant();
          } else {
            this.setState({
              success: false,
              failed: true,
              responseMessage: res.data.responseMessage,
            });
          }
        }
      });
    } else {
      this.setState({
        success: false,
        failed: true,
        responseMessage: "Invalid Form",
      });
    }
  }

  showDetailsPanel(data) {
    ApiService.fetchMerchantDocuments(data[0].id).then((res) => {
      this.setState({ documents: res.data });
    });

    this.setState({ selectedMerchant: data[0], showDetails: true });
  }

  hideDetailsPanel() {
    this.setState({ showDetails: false });
  }

  onMerchantChange = (event, newValue) => {
    let selMercht = newValue ? newValue : null;
    if (selMercht) {
      this.setState({
        merchant: selMercht,
      });
      ApiService.fetchMerchantById(selMercht.id).then((res) => {
        if (typeof res.data === "string" && res.data === "") {
          this.setState({
            merchants: [],
          });
        } else {
          this.setState({
            merchants: [res.data],
          });
        }
      });
    } else {
      this.setState({
        merchant: null,
      });
      this.fetchAllMerchants();
    }
  };

  render() {
    const { classes } = this.props;
    const { selectedMerchant } = this.state;

    return (
      <>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Merchants
          </Typography>
          <Divider light className={classes.searchbar} />

          <GridContainer style={{ marginTop: "1em", marginBottom: "1em" }}>
            <GridItem xs={8} sm={8} md={4} lg={3}>
              <FormControl fullWidth>
                <Autocomplete
                  value={this.state.merchant}
                  onChange={this.onMerchantChange}
                  options={this.state.allMerchants}
                  getOptionLabel={(option) =>
                    option ? option.merchantName + "-" + option.code : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      labelId="merchantSelectLabel"
                      label="Merchants"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
            </GridItem>
          </GridContainer>

          <MaterialTable
            title="Merchants"
            icons={TableIcons.icons}
            columns={[
              {
                field: "id",
                title: "Id",
                render: (rowData) => (
                  <CustomTooltip title={rowData.id} copy={true}>
                    <InfoOutlinedIcon />
                  </CustomTooltip>
                ),
              },
              { field: "merchantName", numeric: false, title: "Name" },
              { field: "contactEmail", numeric: false, title: "Email" },
              { field: "telephone", numeric: false, title: "Phone" },
              {
                field: "orgRegistrationNumber",
                numeric: false,
                title: "Reg No",
              },
            ]}
            data={this.state.merchants}
            actions={[
              {
                tooltip: "Show details",
                icon: (props) => (
                  <MTButton variant="contained" color="primary" size="small">
                    Details
                  </MTButton>
                ),
                onClick: (evt, data) => this.showDetailsPanel(data),
              },
              // {
              // 	icon: (props)=> <MTButton color="primary" size="sm"><AddIcon />Add Merchant</MTButton>,
              // 	tooltip: 'Add Merchant',
              // 	isFreeAction: true,
              // 	onClick: (event) => this.showAddMerchantDialogue(),
              // },
              {
                tooltip: "Manage Merchant URL/IP",
                icon: (props) => (
                  <MTButton variant="contained" color="primary" size="small">
                    Merchant URL/IP
                  </MTButton>
                ),
                onClick: (evt, data) => this.showAddMerchantUrlPanel(data),
              },
            ]}
            options={{
              search: false,
              exportButton: false,
              pageSize: 30,
              pageSizeOptions: [15, 30, 45],
              padding: "dense",
              showEmptyDataSourceMessage: true,
              selection: true,
              emptyRowsWhenPaging: false,
            }}
          />

          <Dialog open={this.state.showDetails} onClose={this.hideDetailsPanel}>
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideDetailsPanel}
            >
              Merchant details
            </DialogTitle>

            <DialogContent>
              {selectedMerchant && (
                <>
                  {this.state.failed && (
                    <Alert severity="error" elevation="0">
                      {" "}
                      {this.state.responseMessage}
                    </Alert>
                  )}
                  {this.state.success && (
                    <Alert severity="success" elevation="0">
                      {this.state.responseMessage}
                    </Alert>
                  )}
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="right"
                          className={classes.tableHeader}
                        >
                          {this.state.editingMerchant ? (
                            <Button
                              variant="contained"
                              onClick={this.stopEditMerchant}
                              color="primary"
                              size="sm"
                              style={{
                                marginLeft: "2px",
                                marginTop: "1px",
                                position: "absolute",
                                top: "10px",
                                right: "30px",
                              }}
                            >
                              Cancel
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              onClick={this.startEditMerchant}
                              startIcon={<EditIcon />}
                              color="primary"
                              size="sm"
                              style={{
                                marginLeft: "2px",
                                marginTop: "1px",
                                position: "absolute",
                                top: "10px",
                                right: "30px",
                              }}
                            >
                              Edit
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* <TableRow>
                        <TableCell align="left">Merchant Id</TableCell>
                        <TableCell align="left">{this.state.id}</TableCell>
                      </TableRow> */}
                      <TableRow className={classes.tableRowDark}>
                        <TableCell align="left">Merchant name</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.merchantName}
                              placeholder="Merchant name"
                              name="merchantName"
                              onChange={this.handleInputChange}
                            />
                          ) : (
                            <>{selectedMerchant.merchantName}</>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Business Email</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.contactEmail}
                              name="contactEmail"
                              onChange={this.handleInputChange}
                              placeholder="Contact email"
                            />
                          ) : (
                            <>{selectedMerchant.contactEmail}</>
                          )}
                          {this.state.errors.contactEmail.length > 0 && (
                            <span className="error">
                              {this.state.errors.contactEmail}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow className={classes.tableRowDark}>
                        <TableCell align="left">Business Address</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <>
                              <TextField
                                value={selectedMerchant.address}
                                name="address"
                                onChange={this.handleInputChange}
                                placeholder="Address"
                              />
                              <br />
                              <TextField
                                value={selectedMerchant.city}
                                name="city"
                                onChange={this.handleInputChange}
                                placeholder="City"
                              />
                              <br />
                              <TextField
                                value={selectedMerchant.country}
                                name="country"
                                onChange={this.handleInputChange}
                                placeholder="Country (Only 2 char code)"
                              />
                              <br />
                              <TextField
                                value={selectedMerchant.zip}
                                name="zip"
                                onChange={this.handleInputChange}
                                placeholder="Zip"
                              />
                            </>
                          ) : (
                            <>
                              {selectedMerchant.address},{selectedMerchant.city}
                              ,{selectedMerchant.state},
                              {selectedMerchant.country}, {selectedMerchant.zip}
                            </>
                          )}
                          {this.state.errors.country.length > 0 && (
                            <span className="error">
                              {this.state.errors.country}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Merchant Telephone</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.telephone}
                              name="telephone"
                              onChange={this.handleInputChange}
                              placeholder="Business Telephone"
                            />
                          ) : (
                            <>{selectedMerchant.telephone}</>
                          )}
                          {this.state.errors.telephone.length > 0 && (
                            <span className="error">
                              {this.state.errors.telephone}
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow className={classes.tableRowDark}>
                        <TableCell align="left"> Fax</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.fax}
                              name="fax"
                              onChange={this.handleInputChange}
                              placeholder=" fax"
                            />
                          ) : (
                            <>{selectedMerchant.fax}</>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">
                          Merchant Registration number
                        </TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.orgRegistrationNumber}
                              name="orgRegistrationNumber"
                              onChange={this.handleInputChange}
                              placeholder="Merchant Registration number"
                            />
                          ) : (
                            <>{selectedMerchant.orgRegistrationNumber}</>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow className={classes.tableRowDark}>
                        <TableCell align="left"> Industry</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.industry}
                              name="industry"
                              onChange={this.handleInputChange}
                              placeholder=" Industry"
                            />
                          ) : (
                            <>{selectedMerchant.industry}</>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">Website</TableCell>
                        <TableCell align="left">
                          {this.state.editingMerchant ? (
                            <TextField
                              value={selectedMerchant.website}
                              onChange={this.handleInputChange}
                              placeholder="website"
                            />
                          ) : (
                            <>{selectedMerchant.website}</>
                          )}
                        </TableCell>
                      </TableRow>
                      {this.state.editingMerchant && (
                        <TableRow>
                          <TableCell colSpan="2" align="center">
                            <Button
                              variant="contained"
                              onClick={this.handleSubmit}
                              color="primary"
                            >
                              Update
                            </Button>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </>
              )}
            </DialogContent>
          </Dialog>

          {selectedMerchant && (
            <Dialog
              open={this.state.addMerchantUrlPanelVisible}
              onClose={this.hideAddMerchantUrlPanel}
              maxWidth="md"
            >
              <DialogTitle
                id="customized-dialog-url"
                onClose={this.hideAddMerchantUrlPanel}
              >
                Add Merchant Front URL and IP
              </DialogTitle>
              <DialogContent>
                <AddMerchantUrlComponent
                  merchantId={selectedMerchant.id}
                  reloadMerchants={this.fetchAllMerchants}
                />
              </DialogContent>
            </Dialog>
          )}

          {/* <Dialog open={this.state.addMerchantPanelVisible} onClose={this.hideAddMerchantDialogue}>
						<DialogTitle id="customized-dialog-title" onClose={this.hideAddMerchantDialogue}>
				          Add Merchant
				        </DialogTitle>
						<DialogContent>
							 <AddMerchant reloadMerchants={this.fetchAllMerchants}/>
						</DialogContent>
					</Dialog> */}
        </Paper>
      </>
    );
  }
}
export default withStyles(useStyles)(MerchantComponent);
